export default __webpack_public_path__ + "static/media/slide8.e5de6138.jpg";